import { fromJS } from 'immutable'

const initialState = fromJS({
  userName: 'Usuario',
  userImage: '/assets/images-DEMO/avatars/user.png',
  uid: 0,
  email: '',
  authorizedApps: [],
  menus: [],
  permissions: [],
  stripeCustomerId: ''
})

const user = (state = initialState, action) => {
  switch (action.type) {
    case 'LOG_IN':
      return state.merge({
        ...action.payload
      })
    case 'SET_STRIPE_CUSTOMER_ID':
      return state.merge({
        ...action.payload
      })
    case 'USER_SET_PERMISSIONS':
      return state.merge({
        permissions: action.payload
      })
    case 'LOG_OUT':
      return state.merge({
        userName: 'Usuario',
        userImage: '/assets/images-DEMO/avatars/user.png',
        uid: 0
      })
    default:
      return state
  }
}

export default user